import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";

interface PhoneFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const PhoneField = ({ form }: PhoneFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="phone"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Phone Number (Optional)</FormLabel>
          <FormControl>
            <Input {...field} placeholder="(212) 555-0123" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};